import { useEffect } from "react";
import { useInfiniteQuery } from "@tanstack/react-query";
import getOrganizationProfiles from "../axios/getOrganizationProfiles";

/**
 * @description This hook is similar to useQueryOrganizationProfiles but it automatically fetches all pages.
 */
const useQueryAllOrganizationProfiles = () => {
  const response = useInfiniteQuery(
    ["organisasi_internasional"],
    ({ pageParam = 1 }) => {
      return getOrganizationProfiles({ page: pageParam });
    },
    {
      getNextPageParam: (lastPage, allPages) => {
        const organizationProfilesList = allPages.flatMap(
          (page) => page.organisasi_internasional.data,
        );
        if (
          organizationProfilesList.length <
          lastPage.organisasi_internasional.total
        ) {
          return lastPage.organisasi_internasional.current_page + 1;
        }
        return undefined;
      },
    },
  );

  const { hasNextPage, isFetchingNextPage, fetchNextPage } = response;

  useEffect(() => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [fetchNextPage, hasNextPage, isFetchingNextPage]);

  return response;
};

export default useQueryAllOrganizationProfiles;
